import { StyleSheet, Text, View } from "@react-pdf/renderer";
import React from "react";

const styles = StyleSheet.create({
    column1: {
        width: '10%',
        justifyContent: 'center',
        alignItems: 'center',

    },
    column2: {
        width: '10%',
        justifyContent: 'center',
        alignItems: 'center',

    },
    column3: {
        width: '80%',
        justifyContent: 'start',
        alignItems: 'start',

    },
    headerText: {
        fontFamily: 'NotoNastaliqUrdu',
    },
    headerText1: {
        fontFamily: 'NotoNastaliqUrdu',
        fontWeight:'bold',
        fontSize: 14,
    },
});

const InvoiveSignature   = () => {

  return (
    <>
            <View style={styles.column1}>
                <Text ></Text>
            </View>
            <View style={styles.column2}>
                <Text></Text>
            </View>
            <View style={styles.column3}>
                <Text style={styles.headerText1}>
                ________________________ : ڈیلیوری دستخط : _________________________وصول دستخط 
                </Text>
            </View>
    </>
  );
};

export default InvoiveSignature  ;
